import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface LinkedinImportLog {
  id: string;
  triggered_by: string;
  status: string;
  fetched_count: number;
  duplicated_count: number;
  inserted_count: number;
  errors: unknown;
  error_message: string | null;
  duration_ms: number | null;
  created_at: string;
}

export function useLinkedinImportLogs(limit = 50) {
  return useQuery({
    queryKey: ["linkedin-import-logs", limit],
    queryFn: async (): Promise<LinkedinImportLog[]> => {
      const { data, error } = await supabase
        .from("linkedin_job_import_logs")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data ?? []) as LinkedinImportLog[];
    },
    staleTime: 30_000,
  });
}
